<template>
  <div class="card text-left inverted size-sm">
    <div class="display-flex flex-column laptop:flex-row laptop:flex-items-center laptop:flex-content-between">
      <div class="margin-bottom-xl laptop:margin-bottom-0 laptop:margin-right-xl">
        <slot name="message">
          <p style="--paragraph-margin-bottom: 0">
            <font-awesome-icon
              :icon="$v6.duotone.faCircleInfo"
              size="xl"
              class="margin-right-sm"
              style="--fa-secondary-opacity: 1; --fa-secondary-color: var(--fa-dk-blue); --fa-primary-color: var(--white)"
            />

            You're viewing
            <template v-if="subject">{{ subject }} for</template>
            v{{ $releases.active.version }}, an older version of Font Awesome.
          </p>
        </slot>
      </div>
      <div>
        <slot name="action">
          <site-link
            :to="link"
            class="accent"
            style="font-weight: var(--font-weight-bold)"
          >
            View the latest!
            <font-awesome-icon
              :icon="$v6.solid.faArrowRight"
              class="margin-left-xs"
            />
          </site-link>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'OldVersionAlert',

    props: {
      subject: {
        type: String
      },
      isIndividualIcon: {
        type: Boolean
      }
    },

    computed: {
      link() {
        switch (this.subject) {
          case 'icons':
            return { name: `latest.icons` }
          case 'docs':
            return { name: `six.docs`, params: { pathMatch: '/' } }
          default:
            if (this.isIndividualIcon) {
              return { name: `latest.icons.detail`, params: { icon: this.subject } }
            } else {
              return { name: `home` }
            }
        }
      }
    }
  }
</script>
